/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PostCreate = {
    properties: {
        content: {
            type: 'string',
            isRequired: true,
        },
        mediaIds: {
            type: 'array',
            contains: {
                type: 'number',
            },
        },
        userMediaIds: {
            type: 'array',
            contains: {
                type: 'string',
            },
        },
        matchId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
